import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import { settingActions, settingObj } from '../store/SettingSlice';
import * as JSTool from '../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, EffectCoverflow, Mousewheel } from 'swiper/modules';

import NavView from '../view/NavView';
import Page0 from './Page0';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import BorderView from '../view/BorderView';
import Page1_mobile from './Page1_mobile';

export default function HomePage(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();
    const [swiper, setSwiper] = React.useState(null);
    const [white, setWhite] = React.useState(0);

    React.useEffect(() => {
        preLoadImg();
    }, []);


    function preLoadImg() {
        let mainfest = [
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n13.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n23.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n33.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n43.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n53.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n63.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/skill_video/role_big_n73.png",

             "https://game-cdn.aplusjapan-game.com/xing_heng/img/map/poster1.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/map/poster2.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/map/poster3.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/map/poster4.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/map/poster5.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/map/poster6.png",

             "https://game-cdn.aplusjapan-game.com/xing_heng/img/feature/f_1.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/feature/f_2.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/feature/f_3.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/feature/f_4.png",
             "https://game-cdn.aplusjapan-game.com/xing_heng/img/feature/f_5.png",
        ];
     
        var preload = {
            startPreload: function () {
                var preload = new window.createjs.LoadQueue(true);
                preload.installPlugin(window.createjs.SOUND);
                preload.installPlugin(window.createjs.VIDEO);

                preload.addEventListener("progress", this.handleFileProgress);
                preload.addEventListener("complete", this.loadComplete);

                preload.setMaxConnections(10);
                preload.loadManifest(mainfest);
            },

            handleFileProgress: function (event) {
                // const num = Math.ceil(event.loaded * 100);
                // console.log('加载进度：' + num);
            },

            loadComplete: function () {
                // console.log('加载完成');
            }
        }
        preload.startPreload();
    }


    return (
        <Stack sx={{
            width: 1,
            height: settingData.height,
            userSelect: 'none',
            overflow: 'hidden',
            position: 'relative',
        }}>
            <NavView />

            <Swiper
                id="home_page_sp"
                className="mySwiper"
                direction={'vertical'}
                slidesPerView={1}
                mousewheel={true}
                modules={[Mousewheel]}
                resistanceRatio={0}
                onSwiper={(sp) => {
                    setSwiper(sp);
                }}
                onActiveIndexChange={(sp) => {
                    dispatch(settingActions.setNavIndex(sp.activeIndex));
                    if (sp.activeIndex == 3) {
                        $('#black_alpha_view').hide();
                        $('#arrow_container').hide();
                    } else {
                        $('#black_alpha_view').show();
                        $('#arrow_container').show();
                    }

                    if (sp.activeIndex == 0 || sp.activeIndex == 2) {
                        setWhite(0);
                    } else {
                        setWhite(1);
                    }

                }}
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                }}>

                <SwiperSlide> <Page0 /></SwiperSlide>
                <SwiperSlide> {settingData.isMobile ? <Page1_mobile /> : <Page1 />}</SwiperSlide>
                <SwiperSlide> <Page2 /></SwiperSlide>
                <SwiperSlide> <Page3 /></SwiperSlide>
            </Swiper>

            <BorderView />

            <Box
                id="black_alpha_view"
                sx={{
                    width: 1,
                    height: '160px',
                    background: 'linear-gradient(#00000000 , #000000dd)',
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 1,
                    pointerEvents: 'none'
                }} />

            <Stack
                id="arrow_container"
                sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'absolute',
                    zIndex: 2,
                    bottom: '8rem',
                    left: 0,
                    right: 0,
                    pb: 1.5,
                }}>

                <Box
                    component={'img'}
                    src={JSTool.getImgPath('home_down.png')}
                    sx={{
                        width: '45rem',
                        mx: 5,
                        opacity: 0.7
                    }} />

            </Stack>

            {/* 分享 */}
            <Stack
                sx={{
                    alignItems: 'center',
                    position: 'absolute',
                    right: '15rem',
                    zIndex: 2,
                    top: '35%',
                    margin: 'auto',
                    filter: `invert(${white})`,
                    display: (settingData.isMobile && settingData.navIndex == 3) ? 'none' : 'flex',
                }}>

                <Box
                    onClick={() => {
                        JSTool.twitterTap();
                    }}
                    component={'img'}
                    src={JSTool.getImgPath('share_tt.png')}
                    sx={{
                        width: '30rem',
                        my: 2,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />

                <Box
                    onClick={() => {
                        JSTool.youTubeTap();
                    }}
                    component={'img'}
                    src={JSTool.getImgPath('share_yg.png')}
                    sx={{
                        width: '35rem',
                        my: 2,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />

                <Box
                    onClick={() => {
                        JSTool.discordTap();
                    }}
                    component={'img'}
                    src={JSTool.getImgPath('share_dis.png')}
                    sx={{
                        width: '33rem',
                        my: 2,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />

                     <Box
                    onClick={() => {
                        JSTool.tiktokTap();
                    }}
                    component={'img'}
                    src={JSTool.getImgPath('tiktok.png')}
                    sx={{
                        width: '30rem',
                        my: 2,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />

                     <Box
                    onClick={() => {
                        JSTool.kwaiTap();
                    }}
                    component={'img'}
                    src={JSTool.getImgPath('kwai.png')}
                    sx={{
                        width: '37rem',
                        my: 2,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />

            </Stack>

        </Stack>
    );

}